import {
  GET_PAGERDUTY_SERVICES,
  GET_PAGERDUTY_SERVICES_FAIL,
  GET_PAGERDUTY_SERVICES_SUCCESS,
  UPDATE_PAGERDUTY_BLUEJAY_TEAM,
  UPDATE_PAGERDUTY_BLUEJAY_TEAM_FAIL,
  UPDATE_PAGERDUTY_BLUEJAY_TEAM_SUCCESS,
  GET_REFRESH_PAGERDUTY_SUCCESS,
  GET_REFRESH_PAGERDUTY_FAIL,
  GET_REFRESH_PAGERDUTY
} from "./actionTypes";

export const getPagerdutyServices = () => ({
  type: GET_PAGERDUTY_SERVICES,
})

export const getPagerdutyServicesSuccess = pagerdutyServices => ({
  type: GET_PAGERDUTY_SERVICES_SUCCESS,
  payload: pagerdutyServices,
})

export const getPagerdutyServicesFail = error => ({
  type: GET_PAGERDUTY_SERVICES_FAIL,
  payload: error,
})

export const updatePagerdutyBluejayTeam = (payload) => ({
  type: UPDATE_PAGERDUTY_BLUEJAY_TEAM,
  payload
})

export const updatePagerdutyBluejayTeamSuccess = (payload) => ({
  type: UPDATE_PAGERDUTY_BLUEJAY_TEAM_SUCCESS,
  payload: payload
})

export const updatePagerdutyBluejayTeamFail = error => ({
  type: UPDATE_PAGERDUTY_BLUEJAY_TEAM_FAIL,
  payload: error,
})

export const getPagerdutyRefresh = () => ({
  type: GET_REFRESH_PAGERDUTY,
})

export const getPagerdutyRefreshSuccess = teams => ({
  type: GET_REFRESH_PAGERDUTY_SUCCESS,
  payload: teams,
})

export const getPagerdutyRefreshFail = error => ({
  type: GET_REFRESH_PAGERDUTY_FAIL,
  payload: error,
})

